// extracted by mini-css-extract-plugin
export default {"content":"PNbFZvhT","text":"eWzQ6C4p","headline":"Tn9ZguMW","icon":"AXQ_QfzG","image":"LtcGe3vJ","mobile":"mobile","time":"CZxV6VhE"};